import React, { useContext, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Icon, Menu, Message, Popup, SemanticICONS } from 'semantic-ui-react';
import { RouteTypes } from '../../routes/constants';
import { El } from './style';
import Languages from './Languages';
import { useAuth } from '~/routes/components/AuthProvider';
import { useTranslation } from 'react-i18next';
import styled, { ThemeContext } from 'styled-components';
import { FARMER_ROLE_SLUG, ThemeType } from '~/Constants';
import ProfileApi from '~/api/services/profile'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Support from './Support';
import Timer from '../Timer';

import Dialog from '../Dialog';
import { LoginPopupsService } from '~/api/services/loginPopups';
import Carousel from '../Carousel';
import Favicon from 'react-favicon';
import Notifications from './Notifications';
import { handleErrors } from '~/utils/helpers';

const TopBar: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const {
    systemData,
    systemData: { logged: { roleSlug, popUpsOnLogin }, openedLoginPopups, isTest },
    setSystemData,
    supportData,
    systemData: { faqSettings, modules },
    onLogout
  } = useAuth();
  const logoutTime = systemData?.roleSettings?.logoutTime
  const faqText = systemData?.texts?.find(text => text.slug === 'faq_text')
  const testPlatformText = systemData?.texts?.find(text => text.slug === 'test_platform_text')
  const navigate = useNavigate();
  const { logoTitle, favIcon } = useContext<ThemeType>(ThemeContext);
  const farmerLogged = roleSlug === FARMER_ROLE_SLUG
  const displayFaqTopBar = faqSettings.positions.find(position => position === 'header') && Boolean(faqSettings.status) &&
    modules.find(module => module.slug === 'faq')
  const loginPopupRef = useRef<HTMLHeadingElement>(null)

  const [statePopupsLogin, setStateTrackPopusLogin] = useState(openedLoginPopups)
  const [avatar, setAvatar] = useState('')
  const [loginPopups, setLoginPopups] = useState([])
  const [isBusy, setIsBusy] = useState(false)
  const [loadingPopups, setLoadingPopups] = useState(false)
  const [isLoginPopupDisabled, setIsLoginPopupDisabled] = useState(popUpsOnLogin)

  useEffect(() => {
    fetchFileProfile()
  }, [])

  useEffect(() => {
    fetchLoginPopups()
  }, [statePopupsLogin])

  async function fetchLoginPopups() {
    setLoadingPopups(true)
    try {
      const responseLoginPopups = await LoginPopupsService.getFarmerLoginPopups()
      setLoginPopups(responseLoginPopups.data)
    } catch (error) {
      // do nothing
    }
    setLoadingPopups(false)
  }

  async function fetchFileProfile() {
    try {
      const response = await ProfileApi.getFileProfile()
      if (!openedLoginPopups) {
        const responseLoginPopups = await LoginPopupsService.getFarmerLoginPopups()
        setLoginPopups(responseLoginPopups.data)
      }
      setAvatar(response.data)
    } catch (error) {
      // do nothing
    }
  }

  const leftSide = () => {
    return <El.BrandLogo
      key={'1'}
      style={{ backgroundImage: `url(${logoTitle})`, filter: 'drop-shadow(2px 4px 6px black)' }}
    ></El.BrandLogo>
  }

  const rightSide = () => (
    <>
      {Boolean(isTest) && <El.StyledMenuItemText key={'testPlatformText'}>
        <El.StyledTextWrapper>
          <Popup
            content={testPlatformText?.translation}
            trigger={<Icon name='info circle' />}
          />
          <div className='text'>{testPlatformText?.translation}</div>
        </El.StyledTextWrapper>
      </El.StyledMenuItemText>
      }
      <Menu.Item onClick={() => navigate(RouteTypes.PROFILE)} key={'1'}>
        <Popup
          content={t('My user profile')}
          trigger={
            <div
              style={{ display: 'flex', color: 'white', cursor: 'pointer', alignItems: 'center' }}
            >
              {avatar ? <El.StyledProfileWrapper>
                <LazyLoadImage
                  alt={''}
                  effect='blur'
                  src={avatar} />
              </El.StyledProfileWrapper> : <Icon name='user circle' size='big' />}
              <p style={{ fontSize: 15, fontWeight: 500, marginLeft: 5 }}>
                {systemData?.logged.name}
              </p>
            </div>
          }
        />
      </Menu.Item>
      {logoutTime > 0 && <Menu.Item style={{ padding: '0px 1.14285714em' }} key={'timer'}>
        <Timer logoutTime={logoutTime} />
      </Menu.Item>
      }
      {displayFaqTopBar && <Menu.Item onClick={() => navigate(RouteTypes.FAQ)} key={'3'}>
        <Popup
          content={faqText.translation}
          trigger={
            <div
              style={{ display: 'flex', color: 'white', cursor: 'pointer', alignItems: 'center' }}
            >
              <Icon name={faqSettings?.icon as SemanticICONS} size='large' />
            </div>
          }
        />
      </Menu.Item>
      }
      <Menu.Item key={'5'}>
        <Languages />
      </Menu.Item>
      <Menu.Item onClick={() => navigate(RouteTypes.PROFILE_SETTINGS)} key={'2'}>
        <Popup
          content={t('Profile settings')}
          trigger={
            <div
              style={{ display: 'flex', color: 'white', cursor: 'pointer', alignItems: 'center' }}
            >
              <Icon name='cog' size='large' />
            </div>
          }
        />
      </Menu.Item>
      {farmerLogged && <Menu.Item key={'8'}>
        <Notifications />
      </Menu.Item>}
      {/*  {farmerLogged && loginPopups.length > 0 && <Menu.Item
        onClick={() => {
          setSystemData({ ...systemData, openedLoginPopups: false })
          setStateTrackPopusLogin(false)
        }}
        key={'login-popups'}
      >
        <Popup
          content={t('Login popups')}
          trigger={
            <Icon size='large' name='user' style={{ color: 'white', cursor: 'pointer' }} />
          }
        />
      </Menu.Item>
      } */}
      {Boolean(supportData?.status) && farmerLogged && <Menu.Item key={'support'}>
        <Support />
      </Menu.Item>
      }
      <Menu.Item
        onClick={() => onLogout()}
        key={'6'}
      >
        <Popup
          content={t('Log out')}
          trigger={
            <Icon size='large' name='log out' style={{ color: 'white', cursor: 'pointer' }} />
          }
        />
      </Menu.Item>
    </>
  );

  async function handleEnableDisableLoginPopups() {
    setIsBusy(false)
    try {
      if (isLoginPopupDisabled === 0) {
        await LoginPopupsService.disableLoginPopups()
        //notify(t('Successfully disabled popup on login'), 'success');
      } else {
        await LoginPopupsService.enableLoginPopups()
        //notify(t('Successfully enabled popup on login'), 'success');
      }
      setSystemData({
        ...systemData,
        logged: {
          ...systemData.logged,
          popUpsOnLogin: isLoginPopupDisabled ? 0 : 1
        },
        openedLoginPopups: true
      })
    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  function renderLoginPopupsItems() {
    return <StyledContainer>
      <Carousel
        items={loginPopups}
        headerRef={loginPopupRef}
      />
    </StyledContainer>
  }

  function renderNoResults() {
    return <StyledMessage info style={{ margin: '20px auto', maxHeight: 70 }}>
      <Message.Header style={{ padding: 0 }}>{t('No results')}</Message.Header>
      <p>{t('Sorry, there are no login popups to display.')}</p>
    </StyledMessage>
  }

  function renderLoginPopups() {
    return <Dialog
      open={!statePopupsLogin && loginPopups.length > 0}
      textContent={<>
        {loginPopups.length > 0 && !loadingPopups ? renderLoginPopupsItems() : renderNoResults()}
        <El.StyledCheckbox
          label={t('Do not show again')}
          checked={isLoginPopupDisabled === 0}
          onChange={(e, data) => setIsLoginPopupDisabled(data.checked ? 0 : 1)}
        />
      </>}
      htmlContent
      textClose={t('Close')}
      isLoading={isBusy || loadingPopups}
      textHeader={<h2 ref={loginPopupRef}>{''}</h2>}
      handleClose={() => {
        if (isLoginPopupDisabled !== systemData?.logged.popUpsOnLogin) {
          handleEnableDisableLoginPopups()
        } else {
          setSystemData({ ...systemData, openedLoginPopups: true })
        }
      }}
    />
  }

  return <>
    <Favicon url={favIcon} />
    <El.TopBarContainer>
      <El.LeftSideWrapper position='left'>{leftSide()}</El.LeftSideWrapper>
      <El.TopBarMenu>
        <El.RightSideWrapper position='right'>{rightSide()}</El.RightSideWrapper>
      </El.TopBarMenu>
    </El.TopBarContainer>
    {!openedLoginPopups && renderLoginPopups()}
  </>
};

export default TopBar;

const StyledContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 0 auto;
  max-width: 800px;
`;

const StyledMessage = styled(Message)`
 .header {
  padding: 0 !important;
 }
`